export enum Weather {
    sunny,
    partlyCloudy,
    cloudy,
    foggy,
    rainy,
    thunderstorm,
    night,
    snowy
}
